import React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import Button from 'components/button/button';
import { AppUI } from '@seedlang/state';
import { flexCenterColumn } from '@seedlang/style_mixins';

const Wrapper = styled.div`
  ${flexCenterColumn()}
  margin: ${props => props.margin};
`;

@observer
class PatreonButton extends React.Component {

  @computed get clientId() {
    return AppUI.site.patreonClientId;
  }

  @computed get redirectUrl() {
    return `https://${AppUI.site.domainString}/api/patreon_callbacks/oauth`;
  }
  onClick = () => {
    if (AppUI.userIsSignedInAndNotGuest) {
      const authorizationUrl = new URL('https://www.patreon.com/oauth2/authorize');
      authorizationUrl.searchParams.set('response_type', 'code');
      authorizationUrl.searchParams.set('client_id', this.clientId);
      authorizationUrl.searchParams.set('redirect_uri', this.redirectUrl);
      authorizationUrl.searchParams.set('scope', 'identity identity[email] identity.memberships');
      window.location.href = authorizationUrl.toString();
      return;
    }

    localStorage.setItem('showPatreonConnectOnConfirm', 'true');
    AppUI.authenticateStore.redirectRouteNameAfterLogin = 'settings.patreon';
    AppUI.routeStore.routeToNamed('onboarding.register');
  }

  render() {
    return (
      <Wrapper margin={this.props.margin}>
        <Button
          background={AppUI.site.accentColor}
          width={this.props.width}
          fontSize={this.props.fontSize}
          height={this.props.height}
          borderRadius={this.props.borderRadius}
          onClick={this.onClick}
        >
          Connect Patreon Account
        </Button>
      </Wrapper>
    );
  }
}

export default ErrorBoundary(PatreonButton);
